import { useCallback, useEffect, useState } from "react";
import { InfiniteQueryObserverResult } from "react-query";

interface Props {
  hasNextPage?: boolean;
  fetchNextPage: () => Promise<InfiniteQueryObserverResult>;
}

// 무한스크롤 관측 함수 커스텀 훅
const useIntersectionObserver = ({ hasNextPage, fetchNextPage }: Props) => {
  const [target, setTarget] = useState<HTMLDivElement | null>(null);

  // 타켓 관측 콜백함수
  const observerCallback = ([entry]: IntersectionObserverEntry[]) => {
    if (entry.isIntersecting && hasNextPage) {
      fetchNextPage();
    }
  };

  useEffect(() => {
    if (!target) return;
    const observer = new IntersectionObserver(observerCallback); //observer 선언
    observer.observe(target); // 타켓 관측 시작

    return () => observer.unobserve(target); // 타켓 관측 종료
  }, [target, hasNextPage]);

  return { setTarget };
};

export default useIntersectionObserver;
